export class AtlPageChangeEvent extends CustomEvent<{ payload: number }> {
   static EVENT_NAME = 'page-change';

   constructor(detail: { payload: number }) {
      super(AtlPageChangeEvent.EVENT_NAME, {
         detail,
         bubbles: true,
         composed: true,
      });
   }
}

export class AtlActivePageChangeEvent extends CustomEvent<{ payload: number }> {
   static EVENT_NAME = 'set-active-page-change';

   constructor(detail: { payload: number }) {
      super(AtlActivePageChangeEvent.EVENT_NAME, {
         detail,
         bubbles: false,
         composed: false,
      });
   }
}
